import React, { useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Alert, Button, Col, Label, Row, Spinner, TabPane } from "reactstrap";
import Cleave from "cleave.js/react";
import * as Yup from "yup";
import { states } from "../../../../utils/utils";
import { useDispatch } from "react-redux";
import { DASHBOARD_USER_ROLES } from "../../../../constants";
// Formk validation

const Details = ({
  currentUser,
  onUpdateDetails,
  loading,
  successMessage,
  errorMessage,
  setIsEditing,
  isUserInvited,
}) => {
  const isCompanyNameRequired =
    currentUser?.role !== DASHBOARD_USER_ROLES.BROKER;

  const handleChangeInput = (setState) => (e) => {
    setState(e.target.value);
  };

  const initialValues = {
    firstName: currentUser?.firstName || "",
    lastName: currentUser?.lastName || "",
    companyName: currentUser?.companyName || "",
    companyAddress: currentUser?.companyAddress || "",
    state: currentUser?.state || "",
    phoneNumber: currentUser?.phoneNumber || "",
    zipCode: currentUser?.zipCode || "",
    city: currentUser?.city || "",
  };

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    companyAddress: Yup.string().required("Company Address is required"),
    zipCode: Yup.string()
      .matches(/^[0-9]{1,5}$/, "Zip Code is not valid")
      .required("Zip Code is required"),
    phoneNumber: Yup.string()
      .matches(/^[0-9]{10}$/, "Phone Number must be 10 digits long")
      .required("Phone Number is required"),
    state: Yup.string().required("State is required"),
    city: Yup.string().required("City is required"),
    companyName:
      isCompanyNameRequired &&
      Yup.string().required("Company Name is required"),
  });

  const onSubmit = async (values, { setSubmitting }) => {
    console.log(values);
    onUpdateDetails(values);
    setSubmitting(false);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
  };

  return (
    <TabPane tabId="1">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, dirty, isValid, errors }) => {
          return (
            <Form>
              <Row className="">
                <div className="mb-2">
                  <div className="d-flex justify-content-between algin-items-center mb-n2">
                    <h4 className="text-dark fw-semibold">
                      Account Information
                    </h4>
                  </div>
                  <hr />
                </div>
                <Col lg={12} className="mb-4">
                  <Row>
                    <div className="col-6">
                      <Label htmlFor="firstName" className="form-label">
                        First Name
                      </Label>
                      <Field
                        type="text"
                        name="firstName"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="firstName"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                    <div className="col-6">
                      <Label htmlFor="lastName" className="form-label">
                        Last Name
                      </Label>
                      <Field
                        type="text"
                        name="lastName"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="lastName"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Row>
                </Col>
                {!isUserInvited && (
                  <Col lg={12} className="mb-4">
                    <Row>
                      {currentUser?.role !== DASHBOARD_USER_ROLES.BROKER && (
                        <div className="col-6">
                          <Label htmlFor="companyName" className="form-label">
                            Company Name
                          </Label>
                          <Field
                            type="text"
                            name="companyName"
                            className="form-control"
                          />
                          <ErrorMessage
                            name="companyName"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      )}
                      <div
                        className={`${currentUser?.role !== DASHBOARD_USER_ROLES.BROKER
                          ? "col-6"
                          : "col-12"
                          }`}
                      >
                        <Label htmlFor="companyAddress" className="form-label">
                          Company Address
                        </Label>
                        <Field
                          type="text"
                          name="companyAddress"
                          className="form-control"
                        />
                        <ErrorMessage
                          name="companyAddress"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                    </Row>
                  </Col>
                )}
                <Col lg={12} className="mb-4">
                  <Row>
                    <div className="col-6">
                      <Label htmlFor="phoneNumber" className="form-label">
                        Phone Number
                      </Label>
                      <Field name="phoneNumber">
                        {({ field, form, meta }) => (
                          <Cleave
                            {...field}
                            className="form-control"
                            options={{
                              numericOnly: true,
                              delimiters: [, "(", ")-", "-"],
                              blocks: [0, 0, 3, 3, 4],
                              delimiterLazyShow: true,
                            }}
                            onChange={(e) => {
                              form.setFieldValue(
                                "phoneNumber",
                                e.target.rawValue
                              );
                            }}
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="phoneNumber"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                    {!isUserInvited && (
                      <div className="col-6">
                        <Label htmlFor="state" className="form-label">
                          State
                        </Label>
                        <Field
                          as="select"
                          name="state"
                          className="form-control"
                        >
                          <option value="" disabled>
                            Select State
                          </option>
                          {states.map((state, index) => (
                            <option key={index} value={state}>
                              {state}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="state"
                          component="div"
                          className="text-danger mb-0"
                        />
                      </div>
                    )}
                  </Row>
                </Col>
                {!isUserInvited && (
                  <Col lg={12} className="mb-4">
                    <Row>
                      <Col sm={6}>
                        <Label htmlFor="zipCode" className="form-label">
                          Zip Code
                        </Label>
                        <Field
                          onInput={(e) => {
                            if (e.target.value.length > 5)
                              e.target.value = e.target.value.slice(0, 5);
                          }}
                          type="number"
                          name="zipCode"
                          className="form-control"
                        />
                        <ErrorMessage
                          name="zipCode"
                          component="div"
                          className="text-danger"
                        />
                      </Col>
                      <Col sm={6}>
                        <Label htmlFor="city" className="form-label">
                          City/Town
                        </Label>
                        <Field name="city" className="form-control" />
                        <ErrorMessage
                          name="city"
                          component="div"
                          className="text-danger"
                        />
                      </Col>
                    </Row>
                  </Col>
                )}
              </Row>
              <div className="col-12 justify-content-start align-items-center d-flex ">
                <Button
                  color="soft-primary"
                  onClick={handleCancelEdit}
                  className="btn btn-soft-primary border border-primary mb-0 me-3 px-5"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  color="primary"
                  disabled={
                    isSubmitting || loading || !dirty
                    // || !isValid
                  }
                  className={`btn btn-primary mb-0 `}
                >
                  {loading ? (
                    <Spinner size="sm" className="me-2">
                      {" "}
                      Loading...{" "}
                    </Spinner>
                  ) : null}
                  Update Information
                </Button>

                <div className="col-4 mt-1 justify-content-end">
                  {successMessage && (
                    <Alert color="success" className="p-2 mt-n1 mb-0">
                      Profile Updated Successfully
                    </Alert>
                  )}
                  {errorMessage && (
                    <Alert color="danger" className="p-2 mt-n1 mb-0">
                      {errorMessage}
                    </Alert>
                  )}
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </TabPane>
  );
};

export default Details;
